import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Section";
import api from "@/lib/api";

export default function Blog() {
  const [data, setData] = useState({ items: [] });
  useEffect(() => { api.get("/blog").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <Seo title="Blog — Recruitment, HR & Career Advice" description="Insights on recruitment, hiring, jobs, career advice, resume and interview tips from Dreamzz HR & Consultancy." />
      <PageHeader eyebrow="Insights" title="Blog & Career Advice" subtitle="Recruitment insights, hiring tips and career guidance for employers and job seekers." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {data.items.map((b, i) => (
          <Reveal key={b.id} delay={i * 40}>
            <Link to={`/blog/${b.slug}`} data-testid={`blog-${b.slug}`} className="group glass card-hover rounded-2xl overflow-hidden flex flex-col h-full">
              {b.featured_image ? (
                <img src={b.featured_image} alt={b.title} className="h-44 w-full object-cover" />
              ) : (
                <div className="h-44 w-full bg-gradient-to-br from-brand-emerald/20 to-brand-blue/20 grid place-items-center"><span className="font-display font-bold text-3xl text-white/20">Dreamzz HR</span></div>
              )}
              <div className="p-5 flex flex-col flex-1">
                <span className="eyebrow">{b.category}</span>
                <h3 className="font-display font-bold text-lg mt-2 group-hover:text-brand-emerald transition-colors">{b.title}</h3>
                <p className="text-sm text-slate-400 mt-2 flex-1">{b.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm text-brand-emerald font-medium">Read more <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </section>
    </PublicLayout>
  );
}
